import * as yup from "yup";

export const invalidCpf = [
  "000.000.000-00",
  "111.111.111-11",
  "222.222.222-22",
  "333.333.333-33",
  "444.444.444-44",
  "555.555.555-55",
  "666.666.666-66",
  "777.777.777-77",
  "888.888.888-88",
  "999.999.999-99",
];

export const schema = yup.object().shape({
  email: yup
    .string()
    .email("O e-mail deve ser formatado corretamente")
    .required("Preencha esse campo obrigatório."),
  computer: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  firstname: yup.string().required("Preencha esse campo obrigatório."),
  lastname: yup.string().required("Preencha esse campo obrigatório."),
  gender: yup
    .string()
    .typeError("Preencha esse campo obrigatório.")
    .required("Preencha esse campo obrigatório."),
  birthDate: yup
    .date()
    .typeError("Preencha esse campo obrigatório.")
    .required("Preencha esse campo obrigatório."),
  phone: yup
    .string()
    .matches("^[0-9]", { message: "Deve conter apenas números" })
    .max(11, "Digite um número de telefone com no máximo 11 números")
    .min(11, "Insira um número de telefone com pelo menos 11 números.")
    .required("Preencha esse campo obrigatório."),
  cpf: yup
    .string()
    .notOneOf(invalidCpf, "CPF inválido")
    .matches(/(\d{3})(\d{3})(\d{3})(\d{2})/g, {
      message: "Deve conter apenas números",
    })
    .length(11, "Deve conter apenas 11 números")
    .required("Preencha esse campo obrigatório."),
  schooling: yup.string().required("Selecione uma opção no menu suspenso."),
  aboutYou: yup
    .string()
    .typeError("Preencha esse campo obrigatório.")
    .required("Preencha esse campo obrigatório."),
  message: yup.string().optional(),
  privacy: yup
    .boolean()
    .typeError("")
    .oneOf([true], "Preencha esse campo obrigatório.")
    .required("Preencha esse campo obrigatório."),
});
